import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";

/**
 *
 * @param {function} onAnimationFinish
 * @constructor
 */
const FilterAnimation = ({ onAnimationFinish }) => {
    const timer = 1500;
    const dispatch = useDispatch();
    const { tempFilterCacheId } = useSelector(state => state.facetedSearch);

    const [isAnimating, setIsAnimating] = useState(false);
    const [animationCompleted, setAnimationCompleted] = useState(true);
    const [width, setWidth] = useState('0%')

    const timeoutRef = useRef(0);

    useEffect(() => {
        if (tempFilterCacheId) {
            setWidth('0%');
            setIsAnimating(true);
            setAnimationCompleted(false);

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            const fwTimeout = setTimeout(() => {
                setWidth('100%')
            }, 20);

            timeoutRef.current = setTimeout(() => {
                setIsAnimating(false);
                setAnimationCompleted(true);
                setWidth('0%');

                if (typeof onAnimationFinish === 'function') {
                    onAnimationFinish();
                }
            }, timer+50) // Add 50 to let animation finish, even though animation should be exactly the same length.

            return () => {
                clearTimeout(fwTimeout);
                clearTimeout(timeoutRef.current);
            }
        } else {
            setIsAnimating(false);
            setAnimationCompleted(true);
            setWidth('0%');
        }
    }, [tempFilterCacheId, dispatch]);

    if (!isAnimating || animationCompleted) {
        return null
    }

    return (
        <div
            className="faceted-search__submit-animation"
            style={{
                width: width,
                transition: width === '0%' ? `` : `width ${timer}ms linear`
            }}
        />
    );
};

export default React.memo(FilterAnimation);
